export const inboxConstants = {
    INBOX_HISTORY_FETCH: 'INBOX_HISTORY_FETCH',
    INBOX_HISTORY_SUCCESS: 'INBOX_HISTORY_SUCCESS',
    INBOX_HISTORY_UPDATE: 'INBOX_HISTORY_UPDATE',
    INBOX_HISTORY_ERROR: 'INBOX_HISTORY_ERROR',
    INBOX_MESSAGE_ADD: 'INBOX_MESSAGE_ADD',
    INBOX_RESET: 'INBOX_RESET',
};

export const MessageStatus = {
    Sent: 0,
    Delivered: 1,
    Failed: 2,
    Read: 3,
    Deleted: 4,
};

export const MessageContentType = {
    Text: 0,
    Image: 1,
    File: 2,
    Video: 3,
    Audio: 4,
    StoryVideo: 5,
    StoryImage: 6,
    Html: 7,
    Unsupported: 8,
    MediaUnavailable: 9,
};

export const MessageNoticeKey = {
    [MessageContentType.Unsupported]: 'InboxPage.unsupportedMessage',
    [MessageContentType.MediaUnavailable]: 'InboxPage.mediaNotImported',
};

export const MessageMetadata = {
    SentFromWhatsAppBusinessApp: 'sent_from_whatsapp_business_app',
    SentFromWhatsAppApp: 'sent_from_whatsapp_app',
    SentFromMetaBusinessSuite: 'sent_from_meta_business_suite',
};

export const SentFromLabelKey = {
    [MessageMetadata.SentFromWhatsAppBusinessApp]: 'InboxPage.sentFromWhatsAppBusinessApp',
    [MessageMetadata.SentFromWhatsAppApp]: 'InboxPage.sentFromWhatsAppApp',
    [MessageMetadata.SentFromMetaBusinessSuite]: 'InboxPage.sentFromMetaBusinessSuite',
};

export const MessageType = {
    Incoming: 0,
    Outgoing: 1,
    Note: 2,
};

export const InboxHistory = {
    Message: 0,
    ConversationEvent: 1,
};

export const SenderType = {
    User: 0,
    Bot: 1,
    External: 2,
};

export const AssignmentType = {
    User: 0,
    Agent: 1,
    Unassigned: 2,
};

export const INSTAGRAM_ATTACHMENT_ACCEPT = '.jpg,.jpeg,.png,.mp4,.mov,.webm,.wav,.pdf';
